export enum ProductName {
	Match = 'Match',
	Alerts = 'Alerts',
	NewsPage = 'News Page',
	EnAppSys = 'EnAppSys',
	EnergyQuantified = 'Energy Quantified',
	MontelOnline = 'Montel Online',
	MontelMarkets = 'Montel Markets',
	SysPower = 'SysPower',
	FlexInsight = 'FlexInsight',
	DataFabricator = 'Data Fabricator',
	MontelPPA = 'Montel PPA',
	MontelValue = 'Montel Value',
}

export const getProductNameOrNotAvailable = (
	productName: string | undefined,
): string =>
	productName
		? ProductName[productName.toLowerCase() as keyof typeof ProductName]
		: 'N/A';
